//table sorting functions

export function getComparator(order, orderBy) {
  console.log(`getComparator called with order: ${order}, orderBy: ${orderBy}`);
  if (orderBy === "type") {
    return (a, b) => {
      const result = customTypeSort(a, b);
      return order === "asc" ? result : -result;
    };
  }
  if (orderBy === "status") {
    return (a, b) => {
      const result = customstatusSort(a, b);
      return order === "asc" ? result : -result;
    };
  }
  return order === "desc"
    ? (a, b) => decendingComparator(a, b, orderBy)
    : (a, b) => -decendingComparator(a, b, orderBy);
}

function decendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function customTypeSort(a, b) {
  // 1. Charging status (charging first)
  const isACharging = a.battery_status === "CHARGING";
  const isBCharging = b.battery_status === "CHARGING";

  if (isACharging && !isBCharging) return 1;
  if (!isACharging && isBCharging) return -1;

  // 2. WiFi quality (WIFI > 4G > none)
  const wifiPriority = { WIFI: 3, "4G": 2, "": 1, null: 1, undefined: 1 }; // fallback for undefined
  const aWifiRank = wifiPriority[a.wifi] || 0;
  const bWifiRank = wifiPriority[b.wifi] || 0;

  if (aWifiRank > bWifiRank) return 1;
  if (aWifiRank < bWifiRank) return -1;

  // 3. Battery percentage (higher battery first)
  const aBattery = parseFloat(a.battery || 0);
  const bBattery = parseFloat(b.battery || 0);

  if (aBattery > bBattery) return 1;
  if (bBattery < aBattery) return -1;
  
  return 0;
}

function customstatusSort(a, b) {
    const statusPriority = {
        "active": 3,
        "idle": 2,
        "offline": 1,
        null: 1,
        undefined: 1
    };
    const aStatusRank = statusPriority[a.journey_status] || 0;
    const bStatusRank = statusPriority[b.journey_status] || 0;

    console.log(`${a.serial_number}: ${aStatusRank} : ${b.journey_status}`)
    if (aStatusRank > bStatusRank)
      return 1
    if (aStatusRank < bStatusRank)
      return -1

    return 0
}